export const FETCH_LANGUAGE_REQUEST = 'FETCH_LANGUAGE_REQUEST';
export const FETCH_LANGUAGE_SUCCESS = 'FETCH_LANGUAGE_SUCCESS';
export const FETCH_LANGUAGE_FAILURE = 'FETCH_LANGUAGE_FAILURE';

export const CREATE_LANGUAGE_REQUEST = 'CREATE_LANGUAGE_REQUEST';
export const CREATE_LANGUAGE_SUCCESS = 'CREATE_LANGUAGE_SUCCESS';
export const CREATE_LANGUAGE_FAIL = 'CREATE_LANGUAGE_FAIL';
export const CREATE_LANGUAGE_RESET = 'CREATE_LANGUAGE_RESET';

export const DELETE_LANGUAGE_REQUEST = 'DELETE_LANGUAGE_REQUEST';
export const DELETE_LANGUAGE_SUCCESS = 'DELETE_LANGUAGE_SUCCESS';
export const DELETE_LANGUAGE_FAIL = 'DELETE_LANGUAGE_FAIL';
export const DELETE_LANGUAGE_RESET = 'DELETE_LANGUAGE_RESET';

export const UPDATE_LANGUAGE_REQUEST = 'UPDATE_LANGUAGE_REQUEST';
export const UPDATE_LANGUAGE_SUCCESS = 'UPDATE_LANGUAGE_SUCCESS';   
export const UPDATE_LANGUAGE_FAIL = 'UPDATE_LANGUAGE_FAIL';
export const UPDATE_LANGUAGE_RESET = 'UPDATE_LANGUAGE_RESET';
